import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import {buildTree} from '../lib/categories';
import './index.scss';
import Header from '../components/header';
import Hero from '../components/hero';
import Footer from '../components/footer';

const Layout = ({children, data}) => {
  const {
    site: {
      siteMetadata: {title, popularTags, footerLinks},
    },
    allHelpScoutArticle: {edges: articleEdges},
    allHelpScoutCategory: {edges: categoryEdges},
  } = data;

  const navigation = buildTree(categoryEdges, articleEdges);

  return (
    <div>
      <Helmet
        meta={[
          {
            name: 'description',
            content:
              'Frequently asked questions and support documentation for TeamGantt',
          },
        ]}
        title={title}
      />
      <Header articleNavigation={navigation} />
      <main>
        <Hero tags={popularTags} />
        {children()}
      </main>
      <Footer footerLinks={footerLinks} />
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.func,
  data: PropTypes.object,
};

export default Layout;

// eslint-disable-next-line
export const query = graphql`
  query IndexLayoutQuery {
    site {
      siteMetadata {
        title
        popularTags {
          href
          title
        }
        footerLinks {
          heading
          links {
            title
            href
          }
        }
      }
    }
    allHelpScoutCategory(filter: {articleCount: {ne: 0}}) {
      edges {
        node {
          ...CategoryNavFragment
        }
      }
    }
    allHelpScoutArticle(filter: {status: {eq: "published"}}) {
      edges {
        node {
          ...ArticleNavFragment
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js